/*
 * Copyright (c) 2023 CalAmp Corp. All Rights Reserved
 */
import {
  useVBusStatusAction,
  UseVBusStatusActionResult
} from './useVBusStatusAction';

export interface VBusStatusProps {
  setTaskNickNameAction?: (action: string) => void;
}

/**
 * Hook for managing VBUS Status container.
 */
export const useVBusStatus = ({setTaskNickNameAction}: VBusStatusProps): UseVBusStatusActionResult => {
  const {
    setFormState,
    formState,
    actionEntry,
    updateAction,
    getTaskName,
    getName,
    setShowSnackBar,
    showSnackBar
  } = useVBusStatusAction({setTaskNickNameAction});

  return {
    setFormState,
    formState,
    actionEntry,
    updateAction,
    getTaskName,
    getName,
    setShowSnackBar,
    showSnackBar
  };
};
